









































































































































































































































































































































































































































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import moment from 'moment'
import BackofficeAutorizacaoStore from '@/components/Backoffice/Store/BackofficeAutorizacaoStore'
import BackofficeGlobalStore from '@/components/Backoffice/Store/BackofficeGlobalStore'
import SolicitacaoPendenciaStore from '@/components/SolicitacaoPendencia/Store/SolicitacaoPendenciaStore'
import SolicitacaoCancelamentoStore from '@/components/SolicitacaoCancelamento/Store/SolicitacaoCancelamentoStore'
import HistoricoSolicitacaoStore from '@/components/HistoricoSolicitacao/Store/HistoricoSolicitacaoStore'
import SolicitacaoComentariosStore from '@/components/SolicitacaoComentarios/Store/SolicitacaoComentariosStore'
import { CancelarSolicitacaoParam, TipoOrigemEnum, RequestMessage, PendenciaMensagem, TipoMensagemEnum, SolicitacaoAcoesBackofficeEnum, TipoDocumentoUpload, GrupoOpmeTipoEnum } from '@/types/_'
import { timeout, timeoutDefault, groupCollectionByField, maskHour } from '@/utils/common'
import { Autorizacao, PendenciaSolicitacao } from '@/types/core'
import { Carater } from '@/types/interfaces/Solicitacao'

import EventBus from '@/plugins/EventBus'
import SituacaoEnum from '@/types/enum/SituacaoEnum'

@Component
export default class ComponentModalIniciarProcesso extends Vue {
  $refs!: {
    dtPicker: any,
    refConferencia: any,
    pendencia: any,
    refConfirmarPendencia: any,
    protocoloOperadora: any,
    dataReferenciaOperadora: any,
    procedimentoConfiguracaoOperadora: any,
    codigoPrestadorSolicitante: any,
    codigoUnicoMaterial: any
  }

  tipoAutorizacaoAnexo: any = {
    pedidoMedico: true,
    laudo: true,
    cotacaoOpme: true,
    laudoAnestesista: true,
    guiaAutorizacaoDoRoboAutorizacao: true,
    anexoOperadora: false,
    resumo: true,
  }

  step: number = 1
  modalPendencia: boolean = false
  loadPendencia: boolean = false
  loadHistorico: boolean = false
  loadComentarios: boolean = false
  loadNextStep: boolean = false
  loadCancelamento: boolean = false
  loadClose: boolean = false
  loadConfirmar: boolean = false
  loadRetornar: boolean = false
  loadBackStep: boolean = false
  modalConfirmarPendencia: boolean = false
  loadClosePedencia: boolean = false
  loadCloseConfirmarPendencia: boolean = false
  loadUpload: boolean = false
  loadConfirmarPendencia: boolean = false
  loadMensagem: boolean = false
  mensagem: string = ''
  modalConfirmarFornecedor: boolean = false

  inputFiles: any[] = []

  pendenciaSolicitacao: PendenciaSolicitacao.IPendenciaSolicitacao = new PendenciaSolicitacao.PendenciaSolicitacao()

  autorizacao: Autorizacao.IAutorizacao = new Autorizacao.Autorizacao()

  get loadingMensagem() {
    return this.loadMensagem
  }

  set loadingMensagem(val: boolean) {
    this.loadMensagem = val
  }

  get loadingUpload() {
    return this.loadUpload
  }

  set loadingUpload(val: boolean) {
    this.loadUpload = val
  }

  get getMensagem() {
    return this.mensagem
  }

  set getMensagem(texto: string) {
    this.mensagem = texto
  }

  get showModalConfirmarPendencia() {
    return this.modalConfirmarPendencia
  }

  set showModalConfirmarPendencia(value: boolean) {
    this.modalConfirmarPendencia = value
  }

  get loadingClosePendencia() {
    return this.loadClosePedencia
  }

  set loadingClosePendencia(value: boolean) {
    this.loadClosePedencia = value
  }

  get loadingCloseConfirmarPendencia() {
    return this.loadCloseConfirmarPendencia
  }

  set loadingCloseConfirmarPendencia(val: boolean) {
    this.loadCloseConfirmarPendencia = val
  }

  get getMensagens() {
    return this.getPendenciaStore.pendencia.mensagens
  }

  get getTipoMensagemEnum() {
    return TipoMensagemEnum
  }

  get loadingConfirmarPendencia() {
    return this.loadConfirmarPendencia
  }

  set loadingConfirmarPendencia(val: boolean) {
    this.loadConfirmarPendencia = val
  }

  get loadingBackStep() {
    return this.loadBackStep
  }

  set loadingBackStep(value: boolean) {
    this.loadBackStep = value
  }

  get loadingConfirmar() {
    return this.loadConfirmar
  }

  set loadingConfirmar(value: boolean) {
    this.loadConfirmar = value
  }

  get loadingRetornar() {
    return this.loadRetornar
  }

  set loadingRetornar(val: boolean) {
    this.loadRetornar = val
  }

  get getDisplayPendencia() {
    return { nomePaciente: this.getBackofficeGlobalStore.solicitacao.pacienteNome,
      nomeMedico: this.getBackofficeGlobalStore.solicitacao.medicoSolicitante.nome }
  }

  get getStep() {
    return this.step
  }

  set getStep(value: number) {
    this.step = value
  }

  get loadingClose() {
    return this.loadClose
  }

  set loadingClose(value: boolean) {
    this.loadClose = value
  }

  get loadingCancelamento() {
    return this.loadCancelamento
  }

  set loadingCancelamento(value: boolean) {
    this.loadCancelamento = value
  }

  get loadingNextStep() {
    return this.loadNextStep
  }

  set loadingNextStep(value: boolean) {
    this.loadNextStep = value
  }

  get loadingPendencia() {
    return this.loadPendencia
  }

  set loadingPendencia(value: boolean) {
    this.loadPendencia = value
  }

  get loadingHistorico() {
    return this.loadHistorico
  }

  set loadingHistorico(value: boolean) {
    this.loadHistorico = value
  }

  get loadingComentarios() {
    return this.loadComentarios
  }

  set loadingComentarios(value: boolean) {
    this.loadComentarios = value
  }

  get showModalPendencia() {
    return this.modalPendencia
  }

  set showModalPendencia(value: boolean) {
    this.modalPendencia = value
  }

  get getHistoricoSolicitacaoStore() {
    return getModule(HistoricoSolicitacaoStore, this.$store)
  }

  get getBackofficeGlobalStore() {
    return getModule(BackofficeGlobalStore, this.$store)
  }

  get getBackofficeAutorizacaoStore() {
    return getModule(BackofficeAutorizacaoStore, this.$store)
  }

  get getPendenciaStore() {
    return getModule(SolicitacaoPendenciaStore, this.$store)
  }

  get getSolicitacaoCancelamentoStore() {
    return getModule(SolicitacaoCancelamentoStore, this.$store)
  }

  get getComentariosStore() {
    return getModule(SolicitacaoComentariosStore, this.$store)
  }

  get getTipoConfirmacao() {
    return TipoOrigemEnum.Triagem
  }

  get getRequestMessage() {
    return new RequestMessage()
  }

  get showModalIniciarProcesso() {
    const show = this.getBackofficeGlobalStore.modal.iniciarProcesso
    this.toggleHtmlOverflow(show)
    this.scrollToMensagem()
    return show
  }

  set showModalIniciarProcesso(value) {
    if (!value) {
      this.getStep = 1
    }

    this.getBackofficeGlobalStore.setModal({ name: 'iniciarProcesso', value })
  }

  get componentStepTwo() {
    const { temOpme, acoes } = this.getBackofficeGlobalStore.solicitacao
    if (acoes.autorizacaoResolvePendenciaRoboAutorizacao) return 'BackofficeProtocoloOperadora'
    if (temOpme) return 'BackofficeNegociacaoOperadora'
    return 'BackofficeProtocoloOperadora'
  }

  get canShowStepTwo() {
    const { autorizacaoDeveInformarProtocoloDaOperadora, temOpme } = this.getBackofficeGlobalStore.solicitacao
    return autorizacaoDeveInformarProtocoloDaOperadora || temOpme
  }

  get showModalConfirmarFornecedor() {
    return this.modalConfirmarFornecedor
  }

  set showModalConfirmarFornecedor(value: boolean) {
    this.modalConfirmarFornecedor = value
  }

  get showProtocoloOperadora() {
    const { temOpme, situacao, autorizacaoDeveInformarProtocoloDaOperadora, cotacaoOperadorasExtraGrupo } = this.getBackofficeGlobalStore.solicitacao

    if (situacao.key === SituacaoEnum.AnalisePreCotacao) {
      if (cotacaoOperadorasExtraGrupo && cotacaoOperadorasExtraGrupo.faturamentoDiretoComOperadora && autorizacaoDeveInformarProtocoloDaOperadora) return true

      if (this.existsCotacaoChecked) {
        if (this.$refs.protocoloOperadora) {
          const form = this.$refs.protocoloOperadora.$refs.protocoloOperadoraForm
          if (form) {
            form.reset()
            form.resetValidation()
          }
        }
        return false
      }

      return autorizacaoDeveInformarProtocoloDaOperadora
    }

    if (situacao.key === SituacaoEnum.AnalisePreAutorizacao && temOpme) {
      return autorizacaoDeveInformarProtocoloDaOperadora
    }

    return false
  }

  get existsCotacaoChecked() {
    let existsChecked: boolean = false
    const { grupoOpmeDaSolicitacao } = this.getBackofficeGlobalStore.solicitacao
    grupoOpmeDaSolicitacao.forEach((c) => {
      c.opmes.forEach((o) => {
        if (o.fazCotacao) existsChecked = true
      })
    })
    return existsChecked
  }

  grupoOpmeDaSolicitacao() {
    const { grupoOpmeDaSolicitacao } = this.getBackofficeGlobalStore.solicitacao
    return grupoOpmeDaSolicitacao.reduce((acc: any, obj: any) => {
      const opmes = obj.opmes.reduce((y: any, x: any) => {
        y.push({
          opmeId: x.opmeId,
          tipo: x.tipo,
          codigoHospital: x.codigoHospital,
          fazCotacao: !!x.fazCotacao,
          necessitaDeProfissionalAdicional: !!x.necessitaDeProfissionalAdicional,
          valorUnitario: x.valorUnitario,
        })
        return y
      }, [])

      acc.push({ id: obj.id, opmes })

      return acc
    }, [])
  }

  loadEditFornecedores: boolean = false

  get loadingEditFornecedores() { return this.loadEditFornecedores }
  set loadingEditFornecedores(value: boolean) { this.loadEditFornecedores = value }

  async openModalEditarFornecedorOPME() {
    this.loadingEditFornecedores = true
    const request = await this.getBackofficeGlobalStore.getFornecedoresFromApi()
    if (request && request.length > 0) {
      this.getBackofficeGlobalStore.setModal({ name: 'modalEditarFornecedorOPME', value: true })
      this.showModalConfirmarFornecedor = false
    } else {
      EventBus.$emit('setSnackbar', { show: true, text: request.message || `Ocorreu um erro ao buscar fornecedores... ${String.fromCodePoint(0x1f615)}`, icon: 'warning', color: '#C62828' })
    }
    this.loadingEditFornecedores = false
  }

  naoInformadoOuNaoHomologadoInput: string = 'informado'
  get naoInformadoOuNaoHomologado() { return this.naoInformadoOuNaoHomologadoInput }
  set naoInformadoOuNaoHomologado(value: string) { this.naoInformadoOuNaoHomologadoInput = value }

  temNaoInformadoComoFornecedor() {
    const { grupoOpmeDaSolicitacao } = this.getBackofficeGlobalStore.solicitacao
    if (grupoOpmeDaSolicitacao.length === 0) return false
    const algumNaoInformado: boolean[] = []
    grupoOpmeDaSolicitacao.forEach((grupo: any) => {
      grupo.opmes.forEach((opme: any) => {
        if (!opme.fornecedor1) algumNaoInformado.push(false)
        if (!opme.fornecedor2) algumNaoInformado.push(false)
        if (!opme.fornecedor3) algumNaoInformado.push(false)

        // Caso não exista a flag de alertaFornecedorNaoInformado, utilizar o método antigo
        const invalido = (f: string) => {
          const e = f
          return opme[e] === undefined
            ? false
            : opme[e].nome.toUpperCase() === 'NÃO INFORMADO' || !!opme[e].alertaFornecedorNaoInformado
        }

        algumNaoInformado.push(invalido('fornecedor1'))
        algumNaoInformado.push(invalido('fornecedor2'))
        algumNaoInformado.push(invalido('fornecedor3'))
      })
    })
    return algumNaoInformado.some((e: boolean) => e)
  }

  temNaoHomologadoComoFornecedor() {
    const { grupoOpmeDaSolicitacao } = this.getBackofficeGlobalStore.solicitacao
    if (grupoOpmeDaSolicitacao.length === 0) return false
    const algumNaoHomologado: boolean[] = []
    grupoOpmeDaSolicitacao.forEach((grupo: any) => {
      grupo.opmes.forEach((opme: any) => {
        if (!opme.fornecedor1) algumNaoHomologado.push(false)
        if (!opme.fornecedor2) algumNaoHomologado.push(false)
        if (!opme.fornecedor3) algumNaoHomologado.push(false)

        algumNaoHomologado.push(!!opme.fornecedor1 && !!opme.fornecedor1.alertaFornecedorNaoHomologado)
        algumNaoHomologado.push(!!opme.fornecedor2 && !!opme.fornecedor2.alertaFornecedorNaoHomologado)
        algumNaoHomologado.push(!!opme.fornecedor3 && !!opme.fornecedor3.alertaFornecedorNaoHomologado)
      })
    })
    return algumNaoHomologado.some((e: boolean) => e)
  }

  validarProtocoloOperadora() {
    if (this.showProtocoloOperadora) {
      const { protocoloOperadora } = this.$refs
      return protocoloOperadora.$refs.protocoloOperadoraForm.validate()
    }
    return true
  }

  clearProtocoloOperadora() {
    if (this.showProtocoloOperadora) {
      const { protocoloOperadora } = this.$refs
      protocoloOperadora.$refs.protocoloOperadoraForm.resetValidation()
    }
  }

  async confirmar() {
    this.loadingConfirmar = true
    if (this.getPendenciaStore.pendencia.mensagens.length > 0) {
      this.showModalConfirmarPendencia = true
      return
    }

    if (this.temNaoInformadoComoFornecedor()) {
      this.showModalConfirmarFornecedor = true
      this.naoInformadoOuNaoHomologado = 'informado'
      this.loadingConfirmar = false
      return
    }

    if (this.temNaoHomologadoComoFornecedor()) {
      this.showModalConfirmarFornecedor = true
      this.naoInformadoOuNaoHomologado = 'homologado'
      this.loadingConfirmar = false
      return
    }

    if (this.getBackofficeGlobalStore.solicitacao.hospitalEConvenioUtilizamRoboDeAutorizacao
      && this.getBackofficeGlobalStore.solicitacao.temOpme
      && this.getBackofficeGlobalStore.solicitacao.convenioEnviaCodigoUnicoMaterial) {
      const { codigoUnicoMaterial } = this.$refs
      if (codigoUnicoMaterial && !codigoUnicoMaterial.$refs.formCodigoUnicoMaterial.validate()) {
        this.loadingConfirmar = false
        EventBus.$emit('setSnackbar', { show: true, text: 'Há campos a serem preenchidos antes de prosseguir.', icon: 'warning', color: '#C62828' })
        return
      }
    }

    if (this.getBackofficeGlobalStore.solicitacao.hospitalEConvenioUtilizamRoboDeAutorizacao
        && this.HospitalEnviaProcedimentoInternacaoOperadora) {
      if (!this.getFormProcedimentoInternacaoOperadora.validate()) {
        this.loadingConfirmar = false
        EventBus.$emit('setSnackbar', { show: true, text: 'Há campos a serem preenchidos antes de prosseguir.', icon: 'warning', color: '#C62828' })
        return
      }
    }

    if (this.getBackofficeGlobalStore.solicitacao.hospitalEConvenioUtilizamRoboDeAutorizacao) {
      const { formDataSolicitacaoOperadora } = this.$refs.dataReferenciaOperadora.$refs
      if (!formDataSolicitacaoOperadora.validate()) {
        EventBus.$emit('setSnackbar', { show: true, text: 'Informe uma data de referência para a operadora.', icon: 'warning', color: '#C62828' })
        this.loadingConfirmar = false
        return
      }
    }

    if (this.componentStepTwo === 'BackofficeNegociacaoOperadora' && !this.surgerySolicitationHasUrgencyAutorizationEnabled) {
      const { formSuprimentos, formFaturamentoOperadora }: any = this.$refs.refConferencia.$refs.backofficeSuprimentos.$refs

      const allFormValidation: boolean[] = []
      if (formSuprimentos && formSuprimentos.length > 0) formSuprimentos.forEach((form: any) => allFormValidation.push(form.validate()))

      const faturamentoValidation = formFaturamentoOperadora.validate()
      if (!allFormValidation.every(c => c) || !faturamentoValidation) {
        // Quando ocorre esse erro pode ser que um OPME tenha sido adicionado pelo agendamento quando uma pendência estava aberta
        // nesse caso pode ser necessário voltar a solicitação para o status de Análise Pré-Cotação.
        EventBus.$emit('setSnackbar', { show: true, text: 'Existem erros de validação nos suprimentos.', icon: 'warning', color: '#C62828' })
        this.loadingConfirmar = false
        return
      }
    }

    if (this.validarProtocoloOperadora()) {
      await this.enviarGuias()
    }

    this.loadingConfirmar = false
  }

  async enviarGuias() {
    const params: any = {
      acao: this.acoesByEtapa,
      body: {
        protocoloOPME: this.getBackofficeGlobalStore.solicitacao.protocoloOPME,
        protocoloOperadora: this.getBackofficeGlobalStore.solicitacao.protocoloOperadora,
        cotacaoOperadorasExtraGrupo: this.getBackofficeGlobalStore.solicitacao.cotacaoOperadorasExtraGrupo,
        operadoraSenhaProvisoria: this.getBackofficeGlobalStore.solicitacao.operadoraSenhaProvisoria,
        solicitacaoId: this.getBackofficeGlobalStore.solicitacao.id,
      },
    }

    const { grupoOpmeDaSolicitacao } = this.getBackofficeGlobalStore.solicitacao
    if (grupoOpmeDaSolicitacao.length > 0) {
      // @ts-ignore
      params.body.grupoOpmes = this.grupoOpmeDaSolicitacao()

      // Limpar todos os campos inválidos dos OPMES...
      // @ts-ignore
      params.body.grupoOpmes.forEach((grupoOpme: any) => {
        grupoOpme.opmes.forEach((opme: any) => {
          Object.entries(opme).forEach(([key, value]) => {
            // @ts-ignore
            if (['', null, undefined].includes(value)) {
              // eslint-disable-next-line
              delete opme[key]
            }
          })
        })
      })
    }

    // Limpar todos os campos inválidos dos parâmetros a serem enviados para a API...
    Object.entries(params.body).forEach(([key, value]) => {
      // @ts-ignore
      if (['', null, undefined].includes(value)) {
        delete params.body[key]
      }
    })

    if (this.getBackofficeGlobalStore.solicitacao.hospitalEConvenioUtilizamRoboDeAutorizacao
      && this.HospitalEnviaProcedimentoInternacaoOperadora) {
      // @ts-ignore
      params.body.procedimentoInternacao = {
        procedimentoId: this.getBackofficeGlobalStore.procedimentoInternacaoOperadora.procedimentoId,
        quantidade: this.getBackofficeGlobalStore.procedimentoInternacaoOperadora.quantidade,
      }
    }

    if (this.getBackofficeGlobalStore.solicitacao.hospitalEConvenioUtilizamRoboDeAutorizacao) {
      const integracaoOperadora: any = {}
      if (this.getBackofficeGlobalStore.solicitacao.convenioEnviaCodigoPrestadorSolicitante) {
        integracaoOperadora.codigoPrestadorSolicitante = this.getBackofficeGlobalStore.solicitacao.codigoPrestadorSolicitante
      }

      if (this.getBackofficeGlobalStore.solicitacao.temOpme
          && this.getBackofficeGlobalStore.solicitacao.convenioEnviaCodigoUnicoMaterial) {
        integracaoOperadora.codigoUnicoMaterial = this.getBackofficeGlobalStore.solicitacao.codigoUnicoMaterial
      }

      if (integracaoOperadora.codigoPrestadorSolicitante
        || integracaoOperadora.codigoUnicoMaterial) params.body.integracaoOperadora = integracaoOperadora
    }

    const response = await this.autorizacao.enviarGuias(params)

    if (response.success) {
      EventBus.$emit('setSnackbar', { show: true, text: 'Processo enviado com sucesso!', icon: 'done', color: '#2E7D32' })
      this.getBackofficeAutorizacaoStore.deleteSolicitacao(this.getBackofficeGlobalStore.solicitacao.id)
      await this.closeModal()
    } else {
      EventBus.$emit('setSnackbar', { show: true, text: response.message || 'Ocorreu um erro no envio da autorização.', icon: 'warning', color: '#C62828' })
    }
  }

  get acoesByEtapa() {
    const { acoes } = this.getBackofficeGlobalStore.solicitacao

    if (acoes.autorizacaoEvoluiAguardandoPrazoPosTriagem) {
      return SolicitacaoAcoesBackofficeEnum.AutorizacaoEvoluiAguardandoPrazoPosTriagem
    }

    if (acoes.autorizacaoFazAnalisePreAutorizacao || this.surgerySolicitationHasUrgencyAutorizationEnabled) {
      return SolicitacaoAcoesBackofficeEnum.AutorizacaoFazAnalisePreAutorizacao
    }
    if (acoes.autorizacaoFazAnalisePreCotacao) return SolicitacaoAcoesBackofficeEnum.AutorizacaoFazAnalisePreCotacao
    return SolicitacaoAcoesBackofficeEnum.AutorizacaoResolvePendenciaRoboAutorizacao
  }

  get surgerySolicitationHasUrgencyAutorizationEnabled() {
    return this.getBackofficeGlobalStore.solicitacao.utilizaAnalisePreAutorizacaoUrgencia
      && this.getBackofficeGlobalStore.solicitacao.utilizaAguardandoAutorizacaoUrgencia
      && this.surgeryType && this.surgeryType.key === 'Urgencia'
      && (this.surgeryStatus === 'AguardandoAutorizacaoUrgencia' || this.surgeryStatus === 'AnalisePreAutorizacaoUrgencia')
  }

  get surgeryType() {
    return this.getBackofficeGlobalStore.solicitacao.carater as Carater
  }

  get surgeryStatus() {
    return this.getBackofficeGlobalStore.solicitacao.situacao.key
  }

  get HospitalEnviaProcedimentoInternacaoOperadora() {
    if (!['AnalisePreAutorizacao'].includes(this.getBackofficeGlobalStore.solicitacao.situacao.key)) return false
    const { convenioEnviaProcedimentoInternacao } = this.getBackofficeGlobalStore.solicitacao
    if (!convenioEnviaProcedimentoInternacao) return false
    return convenioEnviaProcedimentoInternacao
  }

  get getFormProcedimentoInternacaoOperadora() {
    if (!this.HospitalEnviaProcedimentoInternacaoOperadora) return null

    const { procedimentoConfiguracaoOperadora } = this.$refs
    const { formProcedimentoDeInternacao } = procedimentoConfiguracaoOperadora.$refs
    return formProcedimentoDeInternacao
  }

  @Watch('showModalIniciarProcesso')
  async onChangeShowModalSuprimentos(value) {
    const { codigoHospital } = this.$refs.refConferencia.$refs
    if (value === false && codigoHospital && codigoHospital.length > 0) {
      codigoHospital.forEach((e: any) => {
        e.resetValidation()
        e.reset()
      })
    }

    this.clearProtocoloOperadora()
  }

  async nextStep(step) {
    this.loadingNextStep = true
    await timeoutDefault()

    if (this.getPendenciaStore.pendencia.mensagens.length > 0) {
      this.showModalConfirmarPendencia = true
    } else {
      this.getStep = step
    }

    this.loadingNextStep = false
  }

  async backStep(step) {
    this.loadingBackStep = true
    await timeoutDefault()
    this.getStep = step
    this.loadingBackStep = false
  }


  async showModalCancelamento() {
    this.loadingCancelamento = true
    await timeout(400)
    const cancelarSolicitacaoParam: CancelarSolicitacaoParam = {
      solicitacaoId: this.getBackofficeGlobalStore.solicitacao.id,
      tipoOrigem: TipoOrigemEnum.Agendamento,
      situacao: this.getBackofficeGlobalStore.solicitacao.situacao,
      canceladoMotivo: {
        display: '',
        key: '',
      },
      modal: 'iniciarProcesso',
    }

    if (this.getBackofficeGlobalStore.solicitacao.canceladoMotivo) {
      cancelarSolicitacaoParam.canceladoMotivo = this.getBackofficeGlobalStore.solicitacao.canceladoMotivo
    }

    this.getSolicitacaoCancelamentoStore.setCancelarSolicitacaoParam(cancelarSolicitacaoParam)
    this.getSolicitacaoCancelamentoStore.setShowModalCancelamentoAutorizacao(true)
    await this.getSolicitacaoCancelamentoStore.getMotivosCancelamentoAll({ hospitalId: this.getBackofficeGlobalStore.solicitacao.hospitalId })
    this.loadingCancelamento = false
  }

  async showHistory() {
    this.loadingHistorico = true
    const solicitacaoId = this.getBackofficeGlobalStore.solicitacao.id
    await this.getHistoricoSolicitacaoStore.getHistoricoSolicitacao(solicitacaoId)
    this.loadingHistorico = false
  }

  async showComentario() {
    this.loadingComentarios = true
    const solicitacaoId = this.getBackofficeGlobalStore.solicitacao.id
    await this.getComentariosStore.getComentariosBySolicitacaoId(solicitacaoId)
    this.getComentariosStore.setShowModalComentario(true)
    this.loadingComentarios = false
  }

  async pendencia() {
    this.loadingPendencia = true
    await timeout(800)
    this.showModalPendencia = true
    this.loadingPendencia = false
  }

  async addPendenciaMensagem(mensagem: string) {
    await timeout(400)
    const time = moment().format('YYYY-MM-DDTHH:mm')
    const pendenciaMensagem: PendenciaMensagem = {
      mensagemHospital: true,
      id: '',
      dataEnvio: time,
      tipoMensagem: TipoMensagemEnum.Texto,
      texto: mensagem,
    }

    this.getPendenciaStore.setPendenciaMensagem(pendenciaMensagem)
    this.$refs.pendencia.clearMensagem()
  }

  async addPendenciaFile(documentoId, url, nomeArquivo, tipoMensagem) {
    const time = moment().format('YYYY-MM-DDTHH:mm')

    const pendenciaMensagem: PendenciaMensagem = {
      mensagemHospital: true,
      id: '',
      dataEnvio: time,
      tipoMensagem,
      texto: '',
      documentoId,
      url,
      nomeArquivo,
    }

    this.getPendenciaStore.setPendenciaMensagem(pendenciaMensagem)
  }

  async closeModalCancelamento() {
    EventBus.$emit('setLoadingRequest', { status: this.getRequestMessage.status, text: this.getRequestMessage.init.text })
    await this.closeModal()
    EventBus.$emit('clearLoadingRequest')
  }

  async closeModal() {
    if (this.getBackofficeGlobalStore.valorNegociadoLoading) return
    this.loadingClose = true
    let solicitacaoId = this.getBackofficeGlobalStore.solicitacao.id
    await this.autorizacao.desbloquearSolicitacao(this.getBackofficeGlobalStore.solicitacao.id)
    this.clearProcedimentoConfiguracaoOperadora()
    await this.getBackofficeGlobalStore.closeModalIniciarProcesso()
    this.getPendenciaStore.clearPendencia()
    if (this.$refs.protocoloOperadora) {
      const form = this.$refs.protocoloOperadora.$refs.protocoloOperadoraForm
      if (form) {
        form.reset()
        form.resetValidation()
      }
    }
    this.getStep = 1
    this.getPendenciaStore.clearPendencia()
    this.getPendenciaStore.setModalConfirmar(false)
    this.loadingClose = false
    await this.getBackofficeAutorizacaoStore.loadAgendamentosMedicoSearch(solicitacaoId)
    solicitacaoId = ''
  }

  clearProcedimentoConfiguracaoOperadora() {
    const { procedimentoConfiguracaoOperadora } = this.$refs
    if (this.HospitalEnviaProcedimentoInternacaoOperadora && procedimentoConfiguracaoOperadora) {
      const { formProcedimentoDeInternacao } = procedimentoConfiguracaoOperadora.$refs
      if (formProcedimentoDeInternacao) formProcedimentoDeInternacao.reset()
    }
  }

  groupByDate(value: any) {
    return groupCollectionByField(value)
  }

  formatHour(value: string) {
    return maskHour(value)
  }

  toggleHtmlOverflow(isOpen: Boolean) {
    const html = document.querySelector('html')
    const noOverflowClass = 'modal-is-open'

    if (html !== null) {
      html.classList.remove(noOverflowClass)
      if (isOpen) {
        html.classList.toggle(noOverflowClass)
        document.getElementsByClassName('v-dialog')[0].scrollTop = 0
      }
    }
  }

  scrollToMensagem() {
    const ele = document.getElementsByClassName('scroll-top-iniciar-processo')
    if (ele.length > 0) {
      ele[0].scrollTo(0, 0)
    }
  }

  async closeModalPendencia() {
    this.loadingClosePendencia = true
    await timeoutDefault()
    this.showModalPendencia = false
    this.loadingClosePendencia = false
  }

  async closeModalConfirmarPendencia() {
    this.loadingCloseConfirmarPendencia = true
    await timeoutDefault()
    this.showModalConfirmarPendencia = false
    this.loadingCloseConfirmarPendencia = false
  }

  async confirmarPendencia() {
    this.loadingConfirmarPendencia = true

    const solicitacaoId = this.getBackofficeGlobalStore.solicitacao.id
    const { mensagens } = this.getPendenciaStore.pendencia
    const response = await this.pendenciaSolicitacao.abrirMensagem(solicitacaoId, mensagens)

    if (response.success) {
      this.getBackofficeAutorizacaoStore.deleteSolicitacao(this.getBackofficeGlobalStore.solicitacao.id)
      this.closeModal()
    } else {
      EventBus.$emit('setSnackbar', { show: true, text: response.message || 'Houve um erro ao enviar a pendência.', icon: 'warning', color: '#C62828' })
    }

    await timeoutDefault()
    this.loadingConfirmarPendencia = false
  }

  async inputFileIniciarProcesso(newFile, oldFile) {
    this.loadingUpload = true
    if (newFile.identifier) {
      return
    }

    const form = new FormData()
    form.append('laudos', newFile.file)
    const time = moment().format('YYYY-MM-DDTHH:mm:ss')

    const param: any = {
      hospitalId: this.getBackofficeGlobalStore.solicitacao.hospitalId,
      tipoDocumento: TipoDocumentoUpload.PendenciaHospital,
      formData: form,
    }

    const response = await this.getPendenciaStore.uploadDocumento(param)

    if (response.success) {
      const result = response.data[0]
      const documentoId = result.id
      const { url } = result
      const { nomeArquivo } = result

      const pendenciaMensagem: PendenciaMensagem = {
        mensagemHospital: true,
        id: documentoId,
        dataEnvio: time,
        tipoMensagem: TipoMensagemEnum.Documento,
        texto: '',
        documentoId,
        url,
        nomeArquivo,
      }

      this.getPendenciaStore.setPendenciaMensagem(pendenciaMensagem)
    }

    this.loadingUpload = false
  }

  async sendMensagem() {
    this.loadingMensagem = true
    await timeoutDefault()

    const time = moment().format('YYYY-MM-DDTHH:mm')
    const pendenciaMensagem: PendenciaMensagem = {
      mensagemHospital: true,
      id: '',
      dataEnvio: time,
      tipoMensagem: TipoMensagemEnum.Texto,
      texto: this.getMensagem,
    }

    this.getPendenciaStore.setPendenciaMensagem(pendenciaMensagem)
    this.getMensagem = ''
    this.loadingMensagem = false
  }

  clearMensagem() {
    this.getPendenciaStore.clearMensagem()
  }
  /** Fim - Pendência */

  windowWidth: number = 0
  getWindowWidth() {
    this.windowWidth = document.documentElement.clientWidth
  }

  mounted() {
    this.$nextTick(() => {
      window.addEventListener('resize', this.getWindowWidth)
      this.getWindowWidth()
    })
  }

  updated() {
    this.$nextTick(() => {
      window.addEventListener('resize', this.getWindowWidth)
      this.getWindowWidth()
    })
  }
}
